import { thunk } from 'easy-peasy';
import { debounce } from 'lodash-es';

// https://gist.github.com/krstffr/245fe83885b597aabaf06348220c2fe9
export const debouncedThunk: typeof thunk = (thunkFn) => {
    const debounced = debounce(thunkFn, 1000, { leading: true, trailing: false });
    return thunk(debounced);
};
